import api from "@/api";
export default class ULD {
  constructor(_default) {
    if (_default !== undefined) {
      this._default = _default;
      for (let prop in _default) {
        this[prop] = _default[prop];
      }
    }
  }

  static async list(params) {
    const res = await api.get(`/api/v1/repair/uld/`, params);
    if (res) return res.data;
    return null;
  }

  static async store(payload) {
    const res = await api.post(`/api/v1/repair/create/uld/`, payload, "json");
    if (res) return res.data.data;
    return null;
  }

  static async update(payload) {
    const res = await api.put(
      `/api/v1/repair/update/uld/${payload.id}/`,
      payload,
      "json"
    );
    if (res) return res.data.data;
    return null;
  }

  static async latest(payload) {
    const res = await api.get(`/api/v1/repair/uld_last_id/`, payload);
    if (res) return res.data.data[0];
    return null;
  }

  static async request_part(payload) {
    const res = await api.put(
      `/api/v1/repair/request_parts/${payload.uld_id}/`,
      payload,
      "json"
    );
    if (res) return res.data.data;
    return null;
  }

  static async update_requested_part(payload) {
    const res = await api.put(
      `/api/v1/repair/update_requested_parts/${payload.id}/`,
      payload,
      "json"
    );
    if (res) return res.data.data;
    return null;
  }

  static async get_requested_parts(params) {
    const res = await api.get(`/api/v1/repair/get_requested_parts/`, params);
    if (res) return res.data;
    return null;
  }

  static async delete_requested_part(request_part_id) {
    const res = await api.put(
      `/api/v1/repair/remove_requested_parts/${request_part_id}/`
    );
    if (res) return res.data;
    return null;
  }

  static async jo_list(params) {
    const res = await api.get(`/api/v1/repair/show_jo_list/`, params);
    if (res) return res.data.data;
    return null;
  }

  static async get_stockout_items(params) {
    const res = await api.get(
      `/api/v1/stockout/pending/${params.uld_id}/`,
      params
    );
    if (res) return res.data.data;
    return null;
  }

  static async supervisor_approved(uld_id) {
    const res = await api.put(`/api/v1/repair/supervisor_approved/${uld_id}/`);
    if (res) return res.data;
    return null;
  }

  static async create_damage_parts(payload) {
    const res = await api.post(`/api/v1/repair/create/parts_used/`, payload);
    if (res) return res.data;
    return null;
  }

  static async update_damage_parts(payload) {
    const res = await api.put(
      `/api/v1/repair/update/parts_used/${payload.id}/`,
      payload
    );
    if (res) return res.data;
    return null;
  }

  static async get_damage_parts(params) {
    const res = await api.get(`/api/v1/repair/damage/`, params);
    if (res) return res.data;
    return null;
  }

  static async get_uld_out(params) {
    const res = await api.get(`/api/v1/repair/list/uld_out/`, params);
    if (res) return res.data;
    return null;
  }

  static async uld_out_library(params) {
    const res = await api.get(`/api/v1/repair/uld_out_listings/`, params);
    if (res) return res.data.data;
    return [];
  }

  static async batch_update(params) {
    const res = await api.post(`/api/v1/repair/uld_out_update/`, params);
    if (res) return res.data.data;
    return null;
  }

  static async get_jo_no(params) {
    const res = await api.post(`/api/v1/repair/get_jo_no/`, params);
    if (res) return res.data;
    return null;
  }

  static async post_uld_out(params) {
    const res = await api.post(`/api/v1/repair/create/uld_out/`, params);
    if (res) return res.data;
    return null;
  }

  static async post_invoice(payload) {
    const res = await api.post(`/api/v1/repair/create_uld_invoice/`, payload);
    if (res) return res.data;
    return null;
  }

  static async get_invoice_report(params) {
    let p = {
      is_invoice: 1,
      // is_invoice_report: 1,
      ...params
    };
    const res = await api.get(`/api/v1/repair/uld/`, p);
    if (res) return res.data;
    return null;
  }

  static async get_uld_ber(payload) {
    const res = await api.post(`/api/v1/repair/ber_image/`, payload);
    if (res) return res.data;
    return null;
  }

  static async put_uld_ber(payload) {
    const res = await api.put(
      `/api/v1/repair/upload_uld_ber/${payload.uld_id}/`,
      payload
    );
    if (res) return res.data;
    return null;
  }

  static async delete_uld_ber(payload) {
    const res = await api.put(
      `/api/v1/repair/remove_ber_image/${payload.id}/`,
      payload
    );
    if (res) return res.data;
    return null;
  }

  static async get_damage_descriptions(params) {
    const res = await api.get(`/api/v1/repair/damages_descriptions/`, params);
    if (res) return res.data;
    return null;
  }

  static async create_damage_description(payload) {
    const res = await api.post(
      `/api/v1/repair/create/damages_description/`,
      payload
    );
    if (res) return res.data.data;
    return null;
  }

  static async update_damage_description(payload) {
    const res = await api.put(
      `/api/v1/repair/update/damages_description/${payload.id}/`,
      payload
    );
    if (res) return res.data.data;
    return null;
  }

  static damage_descriptions() {
    let list = [
      { value: "A", text: "Hole in Panel" },
      { value: "B", text: "Bent Extrusion" },
      { value: "C", text: "Cracked Extrusion" },
      { value: "D", text: "Broken Extrusion" },
      { value: "E", text: "Broken Gusset" },
      { value: "F", text: "Broken Corner" },
      { value: "G", text: "Missing Fasteners" },
      { value: "H", text: "Missing Gusset" },
      { value: "I", text: "Missing Corner" },
      { value: "J", text: "Missing/Broken Cross Cable" },
      { value: "K", text: "Velcro Torn" },
      { value: "L", text: "Net Torn" },
      { value: "M", text: "Missing Hardware/Parts" },
      { value: "N", text: "Damaged Straps" },
      { value: "O", text: "Damaged ID Code" },
      { value: "P", text: "Damaged Logo" },
      { value: "Q", text: "Damaged Doc. Pouch" },
      { value: "R", text: "Broken Mesh Rope" },
      { value: "S", text: "Broken Border Rope" },
      { value: "T", text: "Missing Lashing Line" },
      { value: "U", text: "Broken/Missing Steel Cable" },
      { value: "V", text: "Missing/Damaged Hardware" },
      { value: "W", text: "Missing Fasteners" },
      { value: "X", text: "Missing TSO Plate" },
      { value: "Y", text: "Lock assy does not engage properly" },
      { value: "Z", text: "Door does not close properly" },
      { value: "AA", text: "Damage Wheels" },
      { value: "AB", text: "Missing Wheels" },
      { value: "AC", text: "Damage Brake" },
      { value: "AD", text: "Missing Brake" },
      { value: "AE", text: "Damage" },
      { value: "AF", text: "Hole" },
      { value: "AG", text: "Hole/Cut" }
    ];

    list = list.sort((a, b) => a.text.localeCompare(b.text));

    return list;
  }

  static action_taken() {
    return [
      { value: "A", text: "Patched" },
      { value: "B", text: "Straightened" },
      { value: "C", text: "Fitted New Part" },
      { value: "D", text: "Fitted New Fasterners" },
      { value: "E", text: "Tap Out/Seal Small Hole" },
      { value: "F", text: "Welded" },
      { value: "G", text: "Fitted new ID Code/Nos." },
      { value: "H", text: "Fitted New Logo" },
      { value: "I", text: "Sewn Net/Curtain" },
      { value: "J", text: "Fitted New Pallet Net" },
      { value: "K", text: "Fitted New Mesh Rope" },
      { value: "L", text: "Fitted New Border Rope" },
      { value: "M", text: "Fitted New Lashing Line" },
      { value: "N", text: "Fitted New TSO Plate" },
      { value: "O", text: "Fitted New Steel Cable" },
      { value: "P", text: "Cleaned & Adjusted" },
      { value: "Q", text: "Repaired" },
      { value: "R", text: "Replaced Part" },
      { value: "S", text: "Cleaned" },
      { value: "T", text: "Paint Retouched" },
      { value: "U", text: "Re-painted" },
      { value: "V", text: "Tightened" },
      { value: "W", text: "Re-fixed" },
    ];
  }

  static customers() {
    return [
      // { value: "A", text: "Jettainer GmbH" },
      // { value: "B", text: "Etihad Catering" },
      // { value: "C", text: "Etihad Airways" },
      // { value: "D", text: "Unilode" },
      // { value: "E", text: "Nordisk" },
      // { value: "F", text: "Safran" },
      // { value: "G", text: "ACL Airshop" },
      // { value: "H", text: "Dubai Air Wings" },
      // { value: "I", text: "Emirates Airlines" },
      // { value: "J", text: "Kalitta Air" },
      // { value: "K", text: "Presidential Flight" }
      { value: "1", text: "Unilode" },
      { value: "2", text: "Jettainer GmbH" },
      { value: "3", text: "ACL Airshop" },
      { value: "4", text: "Etihad Airways" },
      { value: "5", text: "Emirates Airlines" },
      { value: "6", text: "Etihad Catering" },
      { value: "7", text: "Nordisk" },
      { value: "8", text: "Safran" },
      { value: "9", text: "Presidential Flight" },
      { value: "10", text: "Dubai Air Wings" },
      { value: "11", text: "Kalitta Air" }
    ];
  }

  static async customers_data() {
    const result = await api.get(`/api/v1/repair/customers/`);
    const costumers = [];
    // if (result && result.status == 200) return result.data.data;
    if (result && result.status == 200) {
      const res = result.data.data.data;
      for (const key in res) {
        costumers.push({
          value: res[key].id,
          text: res[key].name,
          codes: res[key].codes
        });
      }
      return costumers;
    }

    return null;

    // return [
    //     // { value: "A", text: "Jettainer GmbH" },
    //     // { value: "B", text: "Etihad Catering" },
    //     // { value: "C", text: "Etihad Airways" },
    //     // { value: "D", text: "Unilode" },
    //     // { value: "E", text: "Nordisk" },
    //     // { value: "F", text: "Safran" },
    //     // { value: "G", text: "ACL Airshop" },
    //     // { value: "H", text: "Dubai Air Wings" },
    //     // { value: "I", text: "Emirates Airlines" },
    //     // { value: "J", text: "Kalitta Air" },
    //     // { value: "K", text: "Presidential Flight" }
    //     { value: "1", text: "Unilode" },
    //     { value: "2", text: "Jettainer GmbH" },
    //     { value: "3", text: "ACL Airshop" },
    //     { value: "4", text: "Etihad Airways" },
    //     { value: "5", text: "Emirates Airlines" },
    //     { value: "6", text: "Etihad Catering" },
    //     { value: "7", text: "Nordisk" },
    //     { value: "8", text: "Safran" },
    //     { value: "9", text: "Presidential Flight" },
    //     { value: "10", text: "Dubai Air Wings" },
    //     { value: "11", text: "Kalitta Air" }
    // ];
  }

  static categories() {
    return [
      { text: "ULD Container", value: "uld_container" },
      { text: "ULD Pallet", value: "uld_pallet" },
      { text: "Pallet Net", value: "pallet_net" },
      { text: "Galley Cart", value: "gallery_cart" },
      { text: "VCB", value: "vcb" },
      { text: "Horse Stall", value: "horse_stall" },
      { text: "Dummy", value: "dummy" }
    ];
  }
}
